












import {Component, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import DeviceShareApi from "@/module/device/DeviceShareApi";
import {handleClipboard} from "@/util/clipboard";
import RefreshButton from "@/component/Button/refresh-button.vue";
import VueQrcode from 'vue-qrcode';

@Component({
  components: {
    RefreshButton,
    VueQrcode,
  }
})
export default class DeviceSharecode extends Vue {

  private deviceId = this.$route.query.did as unknown as number

  private api = Container.get(DeviceShareApi)

  private qrcode = 'https://iot.mulaitek.com?sharecode=placeholder'

  private created() {
    this.getQrcode()
  }

  private async getQrcode() {
    this.qrcode = await this.api.qrcode(this.deviceId)
  }

  private copy = handleClipboard
}
